module.exports = __webpack_public_path__ + "img/companyTitle.05598287.png";